import { useMediaDownload } from '@/api/media'
import { DownloadButton } from '@/components/ui/Button'

export default function DownloadTemplateDirector() {
  const { mutate, isLoading } = useMediaDownload()

  const handleDownload = () => {
    mutate({ path: 'template_kpi_leadership_manajer.xlsx', fileName: 'template_kpi_leadership_manajer.xlsx' })
  }
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor="download-template-kpi-leader">
        Download Template KPI Leadership Foreman, SPV, Manager, dan Director
      </label>
      <DownloadButton id="download-template-kpi-leader" onClick={handleDownload} loading={isLoading}>
        Template KPI Leadership Foreman, SPV, Manager, dan Director
      </DownloadButton>
    </div>
  )
}
